

export class Constants {
    static readonly DBName = "luminicad-db";
    static readonly DocumentTable = "documents";
    static readonly RecentTable = "recents";
}
